// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#hmpSearch div.v-input__slot{background:#fff;background-color:#fff}.mx-auto.v-card{background-color:#f9fafb;box-shadow:0 1px 4px 0 rgba(0,0,0,.18)}.search-term{margin-bottom:10px}.v-select-list{max-height:300px;overflow-y:auto;display:grid;grid-template-columns:repeat(2,1fr);gap:10px}", ""]);
// Exports
module.exports = exports;
